<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="parameter" :inline="true"
				label-width="120px" :rules="rules">
				<!-- 试题 -->
				<el-row>
					<el-col :span="20">
						<el-form-item label="试题" prop="qid">
							<el-input type="textarea" :readonly="true" :rows="2" v-model="parameter.name"
								autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<!-- 当试题类型为4时，显示“有序”复选框 -->
					<el-col v-show="parameter.type == 4" :span="4">
						<el-checkbox v-model="parameter.answer.isSort">有序</el-checkbox>
					</el-col>
				</el-row>

				<!-- 答案 -->
				<el-row>
					<el-col :span="20">
						<el-form-item label="答案" prop="answer">
							<el-input type="textarea" :rows="5"
								v-model="parameter.answer.anwrs ? parameter.answer.anwrs : parameter.answer"
								autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-button type="primary" @click="showTst">刷新分词</el-button>
					</el-col>
				</el-row>

				<!-- 关键字和近义词的输入框 -->
				<el-row>
					<el-col :span="16">
						<el-form-item label="判题关键字" prop="key">
							<el-transfer :titles="['分解备选词', '判题基本关键词']" v-model="keyword"
								:data="hanDatas"></el-transfer>
						</el-form-item>
					</el-col>
					<el-col :span="8">

					</el-col>
				</el-row>
				<el-row v-for="(v, i) in remainSynonyms" :key="v">
					<el-col :span="16">
						<el-form-item :label="'其他关键词' + (i + 1)" prop="key">
							{{ v }}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<!-- 编辑框底部按钮 -->
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确定</el-button>
			<el-button @click="close">取消</el-button>
		</div>
	</popup>
</template>
  
<script>
// 引入组件和API
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/exams/question/question.js';
import syapi from '@/api/exams/synonyms.js';

export default {
	name: 'edit',
	components: {
		popup
	},
	data() {
		return {
			// 数据和状态
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: { answer: { isSort: false } },
			dialogVisibleKm: false,

			keyword: [],  // 关键词key
			oldSids: [],
			hanDatas: [],  // 关键词备选

			synonyms: [],
			remainSynonyms: [],

			rules: {},
			listData: {
				records: []
			}
		};
	},
	methods: {



		// 打开编辑弹框
		open(row, title, disabled, size) {
			this.remainSynonyms = []
			this.keyword = []
			this.hanDatas = []
			this.oldSids = []

			this.parameter = row;
			console.log("this.parameter", row)
			this.parameter.qid = this.parameter.id;
			//this.parameter.id = null;

			if (this.parameter.type == 4) { // 如果是填空题
				if (typeof this.parameter.answer === 'string') {
					try {
						this.parameter.answer = JSON.parse(this.parameter.answer);
						if (this.parameter.answer.anwrs) {
						}
					} catch (error) {
						console.error("Failed to parse JSON:", error);
					}
				}
			}

			this.toHanLP()

			this.disabled = disabled;
			this.$refs.popup.open(title, disabled, '70%');

		}, showTst() {
			console.log("this.keyword", this.keyword)
			console.log("this.hanDatas", this.hanDatas)
		},

		// 执行HanLP分词
		toHanLP() {
			console.log("执行HanLP分词", this.parameter)

			let anwrs = [];

			if (this.parameter.type == 4) { //填空
				anwrs = this.parameter.answer.anwrs
			} else {
				anwrs.push(this.parameter.answer)
			}

			console.log("执行HanLP分词 content", anwrs)

			api.toJieba({ anwrs }, res => {
				this.hanDatas = res.data.map((v, i) => ({ key: i, label: v }));
				this.dialogVisibleKm = true;
				console.log(res.data);

				//取回现有判词
				syapi.listByQid({ qid: this.parameter.qid }, res => {
					console.log("取回现有判词", res)
					if (res.data) {
						this.synonyms = res.data
						//回显   this.hanDatas
						this.synonyms.forEach((v, i) => {

							let arrs = v.synonym.split(" ")
							JSON.parse(JSON.stringify(arrs))
							//   穿梭框中的 this.hanDatas [我 的 更新 答案]
							for (let i3 = 0; i3 < this.hanDatas.length; i3++) {
								//与       单类关键词arrs进行比较
								for (let i2 = 0; i2 < arrs.length; i2++) {
									//答案
									if (this.hanDatas[i3].label == arrs[i2]) {
										this.keyword.push(this.hanDatas[i3].key)
										break;
									}
								}
							}
						})

						//剩余的词的回显
						console.log("this.synonyms", this.synonyms)
						//  [答案,更新 刷新 更换]
						//[1,3]

						for (let i2 = 0; i2 < this.synonyms.length; i2++) {

							let synonymTxt = this.synonyms[i2].synonym
							let isNFD = true

							for (let i = 0; i < this.keyword.length; i++) {
								let hanData = this.hanDatas[this.keyword[i]].label
								if (synonymTxt.indexOf(hanData) > -1) {

									let x = synonymTxt.replace(hanData, "").trim()
									if (x.length > 0) {   //只有一个词
										this.remainSynonyms.push(x)
									}
									isNFD = false
									break;
								}
							}
							//没找到的全部加进去
							if (isNFD) {
								this.remainSynonyms.push(synonymTxt)
							}else{
								this.oldSids.push(this.synonyms[i2].id)
							}

						}
						console.log("this.remainSynonyms", this.remainSynonyms)

					}
				})
			});
		},

		// 确定HanLP分词
		comfirmHanLP() {
			this.dialogVisibleKm = false;
		},

		// 关闭弹框
		close() {
			this.disabled = false;
			this.hanDatas = []; // 清空关键词备选数据
			this.$refs.popup.close();
		},

		// 提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {

				this.confirmLoading = true;
				let keywords = []

				if (this.keyword && this.keyword.length > 0) {
					this.keyword.forEach(idx => {
						keywords.push(this.hanDatas[idx].label)
					});
				}

				let parameter = {
					qid: this.parameter.qid,
					oldSid:this.oldSids,
					keywords: keywords
				}

				syapi.merge(parameter, res => {
					this.confirmLoading = false;
					this.close()
					this.$utils.msg.success(res.msg);

				}, err => {
					this.confirmLoading = false;
					this.$utils.msg.warning(err.msg);
				});





			});
		},
	}
};
</script>
  
<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
  